import { Switch, Redirect } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import ErrorRoute from './ErrorRoute';

import {
    Homepage,
    Users,
    AdminUsers,
    AdminUser,
    Error401, 
    Error404,
    QrCodeCheck,
    ProductCheck,
    Registrations,
    Registration,
    NewRegistration,
    SerialNumbers,
    SerialNumber
} from 'views';

import {
    Login,
    ResetPassword,
    ForgotPassword,
    ChangePassword
} from 'views/Account';


let Routes = () => {
    return (
        <Switch>
            <PrivateRoute exact path="/" component={Homepage} />

            <PrivateRoute exact path="/users" component={Users} />

            <PrivateRoute exact path="/adminusers" component={AdminUsers} />
            <PrivateRoute exact path="/adminuser/addnew" component={AdminUser} />
            <PrivateRoute exact path="/adminuser/edit/:id" component={AdminUser} />

            <PrivateRoute exact path="/qrcodecheck" component={QrCodeCheck} />
            <PrivateRoute exact path="/productcheck" component={ProductCheck} />

            <PrivateRoute exact path="/registrations/:email?" component={Registrations} />
            <PrivateRoute exact path="/registration/addnew" component={NewRegistration} />
            <PrivateRoute exact path="/registration/:id" component={Registration} />

            <PrivateRoute exact path="/serialnumbers" component={SerialNumbers} />
            <PrivateRoute exact path="/serialnumber/addnew" component={SerialNumber} />

            <PublicRoute exact path={'/account/login'} component={Login} />
            <PublicRoute exact path={'/account/forgotpassword'} component={ForgotPassword} />
            <PublicRoute exact path={'/account/resetpassword'} component={ResetPassword} />
            <PublicRoute exact path={'/account/changepassword'} component={ChangePassword} />

            <ErrorRoute exact path={'/error401'} component={Error401} />
            <ErrorRoute exact path={'/error404'} component={Error404} />

            <Redirect to="/error404" />
        </Switch>
    )
}

export default Routes;